import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '@/core/api/request-builder';
import { StrictHttpResponse } from '@/core/api/strict-http-response';
import { PcmsoUploadResponse } from '@/core/api/sicom-api/registro/medico/pcmso/pcmso.model';
import { SICOM_PATHS } from 'src/sicom-paths';

/**
 * Upload de documento (PDF) do PCMSO.
 * Content-Type: multipart/form-data com campo 'file'.
 */
export function uploadPcmsoDocumento(http: HttpClient, rootUrl: string, file: File, context?: HttpContext): Observable<StrictHttpResponse<PcmsoUploadResponse>> {
    const rb = new RequestBuilder(rootUrl, uploadPcmsoDocumento.PATH, 'post');
    rb.body({ file }, 'multipart/form-data');

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>): StrictHttpResponse<PcmsoUploadResponse> => r as unknown as StrictHttpResponse<PcmsoUploadResponse>)
    );
}

uploadPcmsoDocumento.PATH = SICOM_PATHS.registro.medico.pcmso.documento;
